import { DashboardDetails } from '../models/dashboard-details';
import { UpdateDashboardInfoRequest } from '../models/dashboard-requests';

export function buildUpdateDashboardInfoRequest(dashboardDetails: DashboardDetails): UpdateDashboardInfoRequest {
    return {
        name: dashboardDetails.name,
        description: dashboardDetails.description,
        abbreviation: dashboardDetails.abbreviation,
        version: dashboardDetails.version ?? 1,
    };
}
